import { hc } from "hono/client";
import type { AppType } from "../../server/app";

/**
 * Formats API error response into a string message.
 * Handles both string errors and validation Issue[] from @hono/standard-validator.
 */
export function formatApiError(error: string | readonly { message: string }[]): string {
  if (typeof error === "string") return error;
  return error.map((issue) => issue.message).join(", ");
}

// Create type-safe RPC client
export const apiClient = hc<AppType>("", {
  init: {
    credentials: "include", // Required for sending cookies cross-origin
  },
  headers: () => ({
    "Accept-Language": localStorage.getItem("lang") || "en",
  }),
}).api;

/**
 * Update a library item via the API. Shared by LibraryItemEditor, LibraryEditor, and Library panel.
 */
export async function updateLibraryItem(libraryId: string, itemId: string, data: Record<string, unknown>) {
  const response = await apiClient.libraries[":id"].items[":itemId"].$put({
    param: { id: libraryId, itemId },
    json: data as any,
  });
  if (!response.ok) {
    const resp = await response.json();
    throw new Error("error" in resp ? formatApiError(resp.error) : "Failed to update item");
  }
  return response.json();
}
